import { render, staticRenderFns } from "./orderPerformanceAccountList.vue?vue&type=template&id=87604952&scoped=true"
import script from "./orderPerformanceAccountList?vue&type=script&lang=js&external"
export * from "./orderPerformanceAccountList?vue&type=script&lang=js&external"
import style0 from "./orderPerformanceAccountList.vue?vue&type=style&index=0&id=87604952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87604952",
  null
  
)

export default component.exports